<template>
	<v-card
		flat
		class="loading-card"
		width="100%"
		border="none"
		data-test="loader-card"
	>
		<div class="loading-card-text sgnl-paragraph-s-regular sgnl-text-color-secondary">
			{{ loadingText }}
			<v-progress-linear
				indeterminate
				color="var(--sgnl-brand-background)"
			/>
		</div>
	</v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
	name: "LoadingCard",
	props: {
		loadingText: { type: String, required: true },
		loadingActive: { type: Boolean, required: false },
	},
});
</script>

<style scoped>
.loading-card {
	background-color: transparent;
}

.loading-card-text {
	padding: var(--sgnl-space-16);
}
</style>
